var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.99 16.99C15.99 17.54 16.44 17.99 16.99 17.99C17.54 17.99 17.99 17.54 17.99 16.99C17.99 16.44 17.54 15.99 16.99 15.99C16.44 15.99 15.99 16.44 15.99 16.99Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.49 8.93C15.79 8.75 15.24 8.2 15.06 7.5H8.93C8.75 8.2 8.2 8.75 7.5 8.93V15.06C8.2 15.24 8.75 15.79 8.93 16.49H15.06C15.24 15.79 15.79 15.24 16.49 15.06V8.93ZM14.5 10.5H12.5V14.99H11.5V10.5H9.5V9.5H14.49V10.5H14.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01 15.99C6.46 15.99 6.01 16.44 6.01 16.99C6.01 17.54 6.46 17.99 7.01 17.99C7.56 17.99 8.01 17.54 8.01 16.99C8.01 16.44 7.56 15.99 7.01 15.99Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01 7.01C8.01 6.46 7.56 6.01 7.01 6.01C6.46 6.01 6.01 6.46 6.01 7.01C6.01 7.56 6.46 8.01 7.01 8.01C7.56 8.01 8.01 7.56 8.01 7.01Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.99 7.01C17.99 6.46 17.54 6.01 16.99 6.01C16.44 6.01 15.99 6.46 15.99 7.01C15.99 7.56 16.44 8.01 16.99 8.01C17.54 8.01 17.99 7.56 17.99 7.01Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM18.94 16.51C19.21 17.58 18.56 18.67 17.49 18.94C16.42 19.21 15.33 18.56 15.06 17.49H8.93C8.75 18.2 8.2 18.76 7.48 18.94C6.41 19.21 5.32 18.56 5.05 17.49C4.78 16.42 5.43 15.33 6.5 15.06V8.93C5.79 8.75 5.23 8.2 5.05 7.48C4.78 6.41 5.43 5.32 6.5 5.05C7.57 4.78 8.66 5.43 8.93 6.5H15.06C15.24 5.79 15.79 5.23 16.51 5.05C17.58 4.78 18.67 5.43 18.94 6.5C19.21 7.57 18.56 8.66 17.49 8.93V15.06C18.2 15.24 18.76 15.79 18.94 16.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTextIcon);
export default __webpack_public_path__ + "static/media/ic-text-icon.892496dda26768b1d7cb627e0c067611.svg";
export { ForwardRef as ReactComponent };